// extracted by mini-css-extract-plugin
export default {"subTitle":"Checklist_subTitle__kacr9"};